import { Locked } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Доступ поддержки dodoc к данным клиники (ПОРТ-03) — решение собственника: запросы по обращениям, подтверждение
 * на срок, отказ, отзыв, журнал действий сотрудника. Ссылка из уведомления — /settings/support-access/<id>.
 */
export const section = defineSection({
  id: 'org.support-access',
  area: 'clinic',
  path: 'settings/support-access/*',
  roles: ['OWNER'],
  icon: Locked,
  titleKey: 'supportAccess:title',
  namespaces: ['portal'],
  navGroup: 'manage',
  order: 25,
  tabGroup: 'clinic',
  load: () => import('./SupportAccessPage'),
});
